import { useContext } from 'react';
import { ApplePayContext } from './ApplePayProvider';

export const useIsApplePaySupported = () => useContext(ApplePayContext).isApplePaySupported;
